var path = '/ssd/jenkins/workspace/Unmanaged/Release_arcade-ui/app/views/dashboard/single-step-container.html';
var html = "<div ng-repeat=\"step in $ctrl.singleSteps\" class=\"border-bottom\">\n  <single-step-banner step=\"step\"></single-step-banner>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
export default  path;